import { toggleCaptionIcon } from '@ts/utils/toggleCaptionIcon';
import { toggleHeight } from '@ts/utils/toggleHeight';

export const setToggleCaption = () => {
  const figureTag = document.querySelectorAll('.js-toggle-caption');

  figureTag.forEach(figure => {
    const toggleButton = figure.querySelector('.bo-image__media__icon');
    const caption = figure.querySelector<HTMLElement>('.bo-image__caption');

    if (!toggleButton || !caption) return;

    toggleButton?.addEventListener('click', () => {
      toggleHeight(caption);
      toggleCaptionIcon(toggleButton as HTMLElement);
    });
  });
};
